export default __webpack_public_path__ + "static/media/SwissChard.2f52944e.jpg";